/**
 * PreHeaderDesktop Component
 *
 * Renders the desktop pre-header section for company details page.
 * Includes the page title ("Company details"), scoring badge, the
 * pending content warning badge and the register status badge.
 */

import HeaderScoringBadge from './HeaderScoringBadge';
import WarningBadge from '../../../common/WarningBadge';
import RegisterStatusBadge from '../../../common/RegisterStatusBadge';

/**
 * @param {Object} props
 * @param {Object} props.company - Company data with scoring and pending status
 * @param {number} props.windowWidth - Current window width for responsive behavior
 */
const PreHeaderDesktop = ({ company, windowWidth }) => {
  return (
    <div className="pre-company-header-desktop">
      <div className="pre-header-title">Company details</div>
      {company.showScoring && (
        <HeaderScoringBadge
          companyId={company.id}
          scoreSecondaryColor={company.scoreSecondaryColor}
          scorePrimaryColor={company.scorePrimaryColor}
          scoreIconFilter={company.scoreIconFilter}
          scoreLabel={company.scoreLabel}
          scoreTooltipText={company.scoreTooltipText}
          scoreTooltipClassName={company.scoreTooltipClassName}
          windowWidth={windowWidth}
          variant="desktop"
        />
      )}
      {!!company.isContentPending && (
        <WarningBadge
          badgeId="company-pending-badge-desktop"
          label="Pending completion"
          tooltipContent={
            <>
              This profile is currently being generated and
              <br />
              may not yet meet content standards.
            </>
          }
          tooltipPosition="bottom-center"
        />
      )}
      <RegisterStatusBadge company={company} tooltipPosition="bottom-center" />
    </div>
  );
};

export default PreHeaderDesktop;
